import applyStyles from '@root/tabulator/RowFormatters/_applyStyles'

export default function (row, cell, params = {}) {
  function shouldApply({ test }) {
    const data = cell.getValue();

    return data === test;
  }

  applyStyles(shouldApply, row.getElement(), cell.getElement(), params);
}